import React from 'react';
import FormatError from './FormatError'
import PropTypes from 'prop-types';

class IpAddress extends React.PureComponent {
    render() {
        return (
            <a href={`https://dnschecker.org/ip-location.php?ip=${this.props.ip}`} target="_blank" rel="noopener noreferrer">{this.props.ip}</a>
        );
    }
}
IpAddress.propTypes = {
    ip: PropTypes.string.isRequired,
}



export default class Logs extends React.PureComponent {
    state = {
        loading: true,
        logs: null,
    };

    componentDidMount() {
        this.loadLogs();
    }

    loadLogs() {
        const arg = window.location.search.substring(1).split('&').map(i => i.split('=')).filter(i => i[0] === 'id')[0];
        const url = '/api/admin/user/logs' + (arg ? `?id=${arg[1]}` : '');
        fetch(url).then(response => response.json())
            .then(result => {
                if (result.result) {
                    this.setState({ loading: false, logs: result.result });
                } else {
                    this.setState({ loading: false, error: result.error });
                }
            });
    }

    render() {
        return (
            <div>
                <h2>Log List</h2>
                {
                    this.state.error && FormatError(this.state.error)
                }
                {
                    this.state.loading && "Loading..."
                }
                {
                    this.state.logs &&
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Time</th>
                                <th>IP</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.logs.map(p => (
                                <tr key={p.id}>
                                    <td>
                                        {p.user.email}
                                    </td>
                                    <td>
                                        {new Date(p.createdAt).toLocaleString()}
                                    </td>
                                    <td>
                                        {p.ip.split(/[, ]+/).filter(i => !!i).map(ip => (
                                            <span key={ip} style={{ marginRight: '8px' }}>
                                                <IpAddress ip={ip} />
                                            </span>
                                        ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}
